<template>
  <store-recherche-provider
    name="demandeImpressionClient"
    :copy="demandeImpressionStore"
    :copyChanges="changesDemandeImpressionStore()"
    :isTemporary="true">
    <liste-demande-impression-onglet
      v-if="mountedLoadingEnd"
      :tiersInformation="tiersInformation"/>
  </store-recherche-provider>
</template>

<script>
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import messageErreur from '@/services/general/messageErreur';
import demandeImpressionStore from '@/store/modules/logistique/demandeImpression';
import listeDemandeImpressionOnglet from '@/components/logistique/demandeImpression/listeDemandeImpressionOnglet';
import * as allTypes from '@/store/mutation-type';
import genererCritereRechercheDemandeImpression from '@/services/logistique/demandeImpression/genererCritereRechercheDemandeImpression';

export default {
  props: {
    tiersInformation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      demandeImpressionStore,
      mountedLoadingEnd: false,
    };
  },
  components: {
    storeRechercheProvider,
    listeDemandeImpressionOnglet,
  },
  methods: {
    changesDemandeImpressionStore() {
      const critere = genererCritereRechercheDemandeImpression();
      critere.clientId = this.tiersInformation.id;
      const initState = {
        items: [],
        total: 0,
        solde: 0,
        maxDatemouvement: null,
        critereRecherche: critere,
        lastPayload: {},
      };
      return {
        state: initState,
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = initState;
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation.nomCommercial }));
      this.mountedLoadingEnd = true;
    } catch (error) {
      messageErreur(this.$i18n);
      throw error;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
